import { useSelector } from 'react-redux';
import { holterStripInfoSelector } from '../selectors/ecg.selectors';
import { msToSecond } from '../../utils/time';

const APP_ROOT = 'cardiologs.com';

export const buildUrl = (
  ecgId: string,
  timestamp: number,
  domain = 'staging',
  highlightedIds: number[] = [],
  selectedCode?: string,
) => {
  const highlightedIdsQuery =
    highlightedIds.length > 0
      ? '&highlighted_ids='.concat(highlightedIds.join('&highlighted_ids='))
      : '';
  const selectedCodeQuery =
    selectedCode != null ? `&selected_code=${selectedCode}` : '';
  const url =
    `https://${domain}.${APP_ROOT}/ambulatory/${ecgId}/viewer?` +
    `timestamp=${timestamp}${highlightedIdsQuery}${selectedCodeQuery}`;
  return url;
};

export const useHolterStripUrl = () => {
  const holterStripInfo = useSelector(holterStripInfoSelector);

  if (holterStripInfo == null) {
    return '#';
  }
  const ecgId = holterStripInfo.parentId;
  const timestamp = msToSecond(holterStripInfo.start);

  if (process.env.NODE_ENV === 'development') {
    return buildUrl(ecgId, timestamp);
  }

  const domain = buildDomain(window.location);

  return buildUrl(ecgId, timestamp, domain);
};

export const buildDomain = (location: Location) => {
  const [prefix] = location.hostname.split(`.${APP_ROOT}`);
  const hostByDot = prefix.split('.');
  const domain = hostByDot[hostByDot.length - 1];
  return domain;
};
